import { Col, Container, Form, Row } from "react-bootstrap";
import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import ZustandSelectBankType from "../../Zustand/ZustandSelectBankType";
import ZustandProductCgi from "../../Zustand/ZustandProductCgi";
import { useEffect } from "react";
import useStore from "../../Zustand/Zustand";
import ZustandDadosDeFinanciamento from "../../Zustand/ZustandDadosDeFinanciamento";

const SelectBankType = () => {
  const { selectInter, setSelectInter } = ZustandSelectBankType();

  const { cgi } = ZustandProductCgi();
  const { resetSimulacoes } = useStore();

  const {
    setTaxaInter,
    setTaxaBrb,
    setTaxaSantander,
    setTaxaItau,
    setTaxaCaixa,
    setTaxaBradesco,
  } = ZustandDadosDeFinanciamento();

  const handleChangeSelectBank = (event) => {
    setSelectInter(event.target.value);
    resetSimulacoes();
    setTaxaInter(0);
    setTaxaBrb(0);
    setTaxaSantander(0);
    setTaxaItau(0);
    setTaxaCaixa(0);
    setTaxaBradesco(0);
  };

  useEffect(() => {
    if (cgi == "CGI") {
      setSelectInter("INTER");
    }
  }, [cgi, setSelectInter]);

  return (
    <Container className="custom-margin-left mt-3 p-0 mb-2" fluid>
      <Row className="d-flex align-items-start">
        <Col
          xs={12}
          lg={3}
          className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
        > 
          <GenerateQuestion
            header="Deseja selecionar quais bancos?"
            subheader="Com isso, você pode escolher o Inter ou outros bancos disponíveis para encontrar a melhor opção para o seu financiamento."
          />
        </Col>
        <Col xs={1} sm={1} md={1} lg={1}></Col>
        <Col className=" me-xl-5 mx-2 ">
          <Col xs={12} md={6} lg={4} className="mb-3">
            <Form.Label className="label">
              Instituição financeira de preferência
              <Col xs={10} sm={6} md={5} lg={9} xl={7}>
                {cgi === "FIN" ? (
                  <Form.Select
                    value={selectInter}
                    onChange={handleChangeSelectBank}
                  >
                    <option value="INTER">INTER</option>
                    <option value="Multibancos">Multibancos</option>
                  </Form.Select>
                ) : (
                  <Form.Select
                    value={selectInter}
                    onChange={handleChangeSelectBank}
                  >
                    <option value="INTER">INTER</option>
                  </Form.Select>
                )}
              </Col>
            </Form.Label>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default SelectBankType;
